/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useCallback, useEffect, useState} from 'react';
import {useStore} from "zustand";
import styles from './UserBlockTab.module.scss';
import groupAPI from "../../../../api/groupAPI";
import InsertBaechaBlock from "./InsertBaechaBlock/InsertBaechaBlock";
import {User} from "../../../../types/User";
import BlockList from "./BlockList/BlockList";
import {BaechaBlockRes} from "../../UserList.interface";
import {useMessageStore} from "../../../../stores/messageStore";
import {useAppStore} from "../../../../stores/appStore";

interface UserBlockTabProps {
	selectedItem: User | undefined;
}

const UserBlockTab = ({ selectedItem }: UserBlockTabProps) => {
	const { setMessages } = useStore(useMessageStore);
	const setShouldShowSpinner = useAppStore((state) => state.setShouldShowSpinner);
	const [blockList, setBlockList] = useState<BaechaBlockRes[]>([]);

	const fetchBlockList = useCallback(async () => {
		if (!selectedItem || !selectedItem.id) return;

		const newBlockList = await groupAPI.getBaechaBlockListByUserId(selectedItem.id);
		setBlockList(newBlockList.sort((a: BaechaBlockRes, b: BaechaBlockRes) => b.createDate - a.createDate));
	}, [selectedItem]);

	const afterSubmit = () => {
		fetchBlockList();
	};

	const onDelete = async (e: any, id: string) => {
		try {
			setShouldShowSpinner(true);
			e.stopPropagation();
			await groupAPI.deleteGroupBaechaBlock(id)
			setMessages('success', '차단 해제 성공');
			await fetchBlockList();
		} catch (e) {
			console.error(e);
		} finally {
			setShouldShowSpinner(false);
		}
	};

	useEffect(() => {
		fetchBlockList();
	}, [fetchBlockList, selectedItem]);

	return selectedItem ? (
		<div className={styles.wrap}>
			{/* 신규 차단 */}
			<div>
				<div className={styles.title}>신규 차단</div>
				<InsertBaechaBlock
					selectedItem={selectedItem}
					afterSubmit={afterSubmit}
				/>
			</div>

			{/* 목록	*/}
			<div style={{ paddingTop: '20px' }}>
				<BlockList
					blockList={blockList}
					onDelete={onDelete}
				/>
			</div>
		</div>
	) : null;
};

export default UserBlockTab;
